import React from 'react';
import InnerPageBanner from '../../../components/InnerPageBanner';
import { Box, Container, Typography, Grid } from '@mui/material';

// Import all 18 benches images
import bench1 from "../../../assets/images/benches1.jpeg";
import bench2 from "../../../assets/images/benches2.jpeg";
import bench3 from "../../../assets/images/benches3.jpeg";
import bench4 from "../../../assets/images/benches4.jpeg";
import bench5 from "../../../assets/images/benches5.jpeg";
import bench6 from "../../../assets/images/benches6.jpeg";
import bench7 from "../../../assets/images/benches7.jpeg";
import bench8 from "../../../assets/images/benches8.jpeg";
import bench9 from "../../../assets/images/benches9.jpeg";
import bench10 from "../../../assets/images/benches10.jpeg";
import bench11 from "../../../assets/images/benches11.jpeg";
import bench12 from "../../../assets/images/benches12.jpeg";
import bench13 from "../../../assets/images/benches13.jpeg";
import bench14 from "../../../assets/images/benches14.jpeg";
import bench15 from "../../../assets/images/benches15.jpeg";
import bench16 from "../../../assets/images/benches16.jpeg";
import bench17 from "../../../assets/images/benches17.jpeg";
import bench18 from "../../../assets/images/benches18.jpeg";

// Create array of all images
const benchImages = [
    bench1, bench2, bench3, bench4,
    bench5, bench6, bench7, bench8,
    bench9, bench10, bench11, bench12,
    bench13, bench14, bench15, bench16,
    bench17, bench18
];

const Benches = () => {
    return (
        <Box>
            <InnerPageBanner title="Benches" />
            <Container sx={{ py: 5 }}>
                <Box sx={{
                    backgroundColor: "#f5f5f5",
                    py: { xs: 4, md: 6 },
                    px: { xs: 2, md: 4 },
                    borderRadius: 2
                }}>
                    {/* ===== Top Hero Section ===== */}
                    <Box
                        sx={{
                            backgroundColor: "#eaeaea",
                            p: { xs: 3, sm: 5, md: 8 },
                            mb: { xs: 5, md: 8 },
                            borderRadius: 2
                        }}
                    >
                        <Typography
                            variant="body2"
                            sx={{ color: "#777", mb: 2, fontSize: { xs: 12, md: 14 } }}
                        >
                            No Doubt We Are Trusted
                        </Typography>

                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: { xs: 24, sm: 28, md: 36 }
                            }}
                        >
                            Benches
                        </Typography>

                        <Box
                            sx={{
                                width: 50,
                                height: 3,
                                backgroundColor: "#1abc9c",
                                my: 2
                            }}
                        />

                        <Box sx={{ mt: 3 }}>
                            <Typography sx={{ fontSize: { xs: 13, md: 14 } }}>
                                <strong>Available Color</strong><br />
                                Grey (White)
                            </Typography>
                        </Box>
                    </Box>

                    {/* ===== Image Gallery Section ===== */}
                    <Typography
                        sx={{
                            fontWeight: 700,
                            mb: 3,
                            fontSize: { xs: 20, md: 24 }
                        }}
                    >
                        Our Bench Models
                    </Typography>

                    <Box sx={{ width: 40, height: 3, backgroundColor: "#1abc9c", mb: 4 }} />

                    <Grid container spacing={4}>
                        {/* All 18 Images in Grid */}
                        {benchImages.map((image, index) => (
                            <Grid size={{ xs: 12, sm: 6, md: 6 }} key={index}>
                                <Box
                                    component="img"
                                    src={image}
                                    alt={`Bench ${index + 1}`}
                                    sx={{
                                        width: "100%",
                                        height: { xs: 200, sm: 220, md: 250 },
                                        objectFit: "cover",
                                        border: "1px solid #ccc",
                                        borderRadius: 2,
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                        transition: 'transform 0.3s',
                                        '&:hover': {
                                            transform: 'scale(1.02)',
                                            boxShadow: '0 8px 20px rgba(0,0,0,0.15)'
                                        }
                                    }}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Container>
        </Box>
    );
};

export default Benches;